/**
 * Classes for a player name the Pitch draws as a link to the player page
 * (SE-8605): the field card lines and the Unassigned rows share them.
 * @module features/scouting/constants/pitchNameLink
 */

/** Keyboard focus ring on the name link's press target. */
export const PITCH_NAME_LINK_FOCUS_CLASS =
  "rounded-sm focus-visible:ring-2 focus-visible:ring-outline-default";

/** The Table view's name-cell affordance: a pointer and an underline on hover. */
export const PITCH_NAME_LINK_TEXT_CLASS =
  "web:cursor-pointer web:hover:underline";
